module.exports = __webpack_public_path__ + "static/img/荣誉_04@2x.7a4187e0.png";